@if (attractionsPassedIn && attractionsPassedIn.length) {
  <div class="attraction-carousel-wrapper">
    <owl-carousel-o [options]="customOptions" class="attraction-carousel">
      @for (_attraction of attractionsPassedIn; track _attraction; let i = $index) {
        <ng-template carouselSlide>
          <div class="carousel-image-wrapper">
            @if (_attraction?.photos[0]?.photo) {
              <img [src]="_attraction.photos[0].photo">
            }
            @if (!_attraction?.photos[0]?.photo) {
              <img [src]="'/assets/images/no_image_available.jpeg'">
            }
          </div>
          <div class="carousel-image-data">
            @if (_attraction?.name) {
              <div
                class="attraction-title"
                [matTooltip]="_attraction.name"
                matTooltipClass="attraction-name"
                [matTooltipPosition]="'above'">
                {{ _attraction.name }}
              </div>
            }
            @if (_attraction?.photos[0]?.html_attributions[0]) {
              <figcaption class="image-cite">
                Photo: <span [innerHTML]="_attraction.photos[0].html_attributions[0] | safeHtml" [matTooltip]="_attraction?.photos[0]?.citeToolTip" [matTooltipPosition]="'above'"></span>
              </figcaption>
            }
            <div class="photo-rating">
              <ngb-rating [(rate)]="_attraction.rating" [readonly]="true" max="5">
                <ng-template let-fill="fill" let-index="i">
                  <span class="star" [class.full]="fill === 100">
                    <span class="half" [style.width.%]="fill">&#11044;</span>&#11044;
                  </span>
                </ng-template>
              </ngb-rating>
            </div>
          </div>
        </ng-template>
      }
    </owl-carousel-o>
    <!--
    <carousel
      class="attraction-carousel"
      [height]="carouselHeight"
      [width]="'100%'"
      [cellsToShow]="numberOfImagesToDisplay"
      [cellsToScroll]="imageAmountToScroll"
      [lightDOM]="lazyLoadOverflowedImages"
      [overflowCellsLimit]="overflowImageLimit">
      <div *ngFor="let _attraction of attractionsPassedIn; let i=index;" class="carousel-cell">
        <div class="carousel-image-wrapper">
          <img *ngIf="_attraction?.photos[0]?.photo" [src]="_attraction.photos[0].photo">
          <img *ngIf="!_attraction?.photos[0]?.photo" [src]="'/assets/images/no_image_available.jpeg'">
        </div>
        <div class="carousel-image-data">
          <div
            *ngIf="_attraction?.name"
            class="attraction-title"
            [matTooltip]="_attraction.name"
            matTooltipClass="attraction-name"
            [matTooltipPosition]="'above'">
            {{ _attraction.name }}
          </div>
          <figcaption class="image-cite" *ngIf="_attraction?.photos[0]?.html_attributions[0]">
            Photo: <span [innerHTML]="_attraction.photos[0].html_attributions[0] | safeHtml" [matTooltip]="_attraction?.photos[0]?.citeToolTip" [matTooltipPosition]="'above'"></span>
          </figcaption>
          <div class="photo-rating">
            <ngb-rating [(rate)]="_attraction.rating" [readonly]="true" max="5">
              <ng-template let-fill="fill" let-index="i">
                <span class="star" [class.full]="fill === 100">
                  <span class="half" [style.width.%]="fill">&#11044;</span>&#11044;
                </span>
              </ng-template>
            </ngb-rating>
          </div>
        </div>
      </div>
    </carousel>
    -->
  </div>
}